import React from "react"
import { graphql } from "gatsby"
import CommonTemplate from "templates/common-template"
import PromotionsList from "components/lists/promotions-list"
import ProgramsList from "components/lists/programs-events-list"
import NewsletterList from "components/lists/newsletter-list"

// markup
const IndexPage = ({ location, data, pageContext }) => {
    let customJsx = null
    if (pageContext.slug === "eip-promotions") {
        const dataList = {
            data: data.promotions,
            url: location.pathname,
        }
        customJsx = <PromotionsList {...dataList} />
    } else if (pageContext.slug === "eip-programmes-and-events") {
        const dataList = {
            data: data.programs,
            url: location.pathname,
        }
        customJsx = <ProgramsList {...dataList} />
    } else if (pageContext.slug === "eip-newsletter") {
        customJsx = <NewsletterList data={data.newsletters} />
    }

    const arrData = {
        location,
        data,
        bgColor:
            "linear-gradient(90deg, #b4e5ff 25%, #bde8ff 25%, #bde8ff 50%, #b4e5ff 50%, #b4e5ff 75%, #bde8ff 75%, #bde8ff 100%)",
        customElement: customJsx,
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

export const query = graphql`
    query WhatsNewQuery($slug: String!) {
        pageData: strapiPage(
            slug: { eq: $slug }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
            }
        }
        promotions: allStrapiPost(
            filter: {
                Post_Type: { eq: "Promotions" }
                maincompany: { shortname: { eq: "dynamics" } }
            }
        ) {
            nodes {
                id
                image {
                    childImageSharp {
                        gatsbyImageData(
                            placeholder: BLURRED
                            width: 400
                            height: 200
                        )
                    }
                }
                Content {
                    Event_Data {
                        custom_link
                    }
                }
                summary
                title
                slug
            }
        }
        programs: allStrapiPost(
            filter: {
                category: { slug: { eq: "programmes-and-events" } }
                maincompany: { shortname: { ne: "Dummy" } }
            }
            sort: { order: DESC, fields: published_at }
        ) {
            edges {
                node {
                    id
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                width: 400
                                height: 200
                            )
                        }
                    }
                    summary
                    title
                    slug
                }
            }
        }
        newsletters: allStrapiPost(
            filter: { Post_Type: { eq: "Newsletter" } }
        ) {
            edges {
                node {
                    id
                    description
                    slug
                    menu_title
                    title
                    Content {
                        id
                        Newsletter_Info {
                            issue
                            url
                            date
                        }
                    }
                    createdAt
                    image {
                        publicURL
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                width: 500
                                height: 300
                            )
                        }
                    }
                }
            }
        }
    }
`
